import './App.css';
import './index.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Header } from './components';
import { Landing, RegistrationForm, InitialForm, FormLayout, LoadingScreen, SwisAccessCode, LAFOIP, SwisAgreementInfo, Submitted } from './containers';
import { StaticDataProvider } from './context/StaticDataContext';

export default function App() {

  return (
    <div className="App fade-in">
      <Header />
      <Routes>
        <Route path="/" element={<FormLayout><Landing /></FormLayout>} />
        <Route path="/lafoip" element={<FormLayout><LAFOIP /></FormLayout>} />
        <Route path="/submit" element={<FormLayout><Submitted /></FormLayout>} />
        <Route path="/swis-agreement" element={<FormLayout><SwisAgreementInfo /></FormLayout>} />
        <Route path="/initial-form"
          element={
            <StaticDataProvider endpoints={{ schools: 'Lkp_School', gradeLevels: 'Lkp_Grade_Level', }}>
              <FormLayout><InitialForm /></FormLayout>
            </StaticDataProvider>
          } />
        <Route path="/swis-access" element={<FormLayout><SwisAccessCode /></FormLayout>} />
        <Route path="/loading" element={<FormLayout><LoadingScreen /></FormLayout>} />
        <Route path="/main-form"
          element={
            <StaticDataProvider>
              <RegistrationForm validateSteps={process.env.REACT_APP_VALIDATE_FORMS === 'true'} /> {/* change validateSteps to enable or disable form validation and sidebar free roam */}
            </StaticDataProvider>
          }
        />
      </Routes>
    </div>
  );
};